/** Appendix A.6: production only; updates never interrupt a shopping session. */
export function registerPwa(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  window.addEventListener(
    'load',
    () => {
      void navigator.serviceWorker
        .register('/sw.js', { scope: '/', updateViaCache: 'none' })
        .catch(() => {
          // Installation is optional; a failed worker must never stop shopping.
        });
    },
    { once: true },
  );
}
